module.exports = __webpack_public_path__ + "static/img/guide-40.078a229e.png";